import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UtensilsCrossed, ArrowLeft } from "lucide-react";
import empApi from "../lib/empApi";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/format";

export default function EmployeeLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await empApi.post("/employee-auth/login", { email, password });
      localStorage.setItem("emp_token", data.token);
      toast.success(`Welcome ${data.employee.name}`);
      navigate("/portal");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-teal-50 dark:from-slate-950 dark:to-slate-900 p-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-slate-900 mb-4">
          <ArrowLeft size={14} /> Admin login
        </Link>
        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-border p-8">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-xl bg-teal-600 flex items-center justify-center text-white">
              <UtensilsCrossed size={22} />
            </div>
            <div>
              <div className="heading text-2xl font-extrabold tracking-tight">Employee Portal</div>
              <div className="text-sm text-muted-foreground">View your orders and balance</div>
            </div>
          </div>
          <h1 className="heading text-xl font-bold mb-1">Sign In</h1>
          <p className="text-sm text-muted-foreground mb-6">Use the email and password your administrator gave you.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email address</Label>
              <Input id="email" data-testid="emp-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" data-testid="emp-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
            </div>
            <Button type="submit" data-testid="emp-login-submit" className="w-full bg-teal-600 hover:bg-teal-700 mt-2" disabled={loading}>
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
